exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dropdown .dropdown-toggle {\n    cursor: pointer;\n}\n\n", ""]);

// exports
